<template>
	<div class="success">
		<img class="image_success" src="@/assets/image/image_lose.png" alt="">
		<div>
			<p style="font-weight: bold;color: red;font-size: 20px;line-height: 36px;">{{$route.query.message}}</p>
			<p><span>{{currTimer}}s</span> <a class="color" v-on:click="toIndex()"> {{ $t('home_page_text') }}</a></p>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'fail',
		data() {
			return {
				timer: 3,
				currTimer: 3
			}
		},
		mounted() {
			this.$analytics.payment.result(false);
			this.setTimer();
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		methods: {
			setTimer: function() {
				let _this = this;
				this.timer = setInterval(function() {
					_this.currTimer = _this.currTimer - 1;
					if (_this.currTimer === 0) {
						clearInterval(_this.timer);
						_this.toIndex();
					}
				}, 1000);
			},
			toIndex: function() {
				this.$router.push({
					path: '/'
				});
			}
		}
	}
</script>

<style></style>
